import React, {useEffect} from 'react'
import { toast } from "sonner"

import { pwaInfo } from 'virtual:pwa-info'

import { useRegisterSW } from 'virtual:pwa-register/react'

console.log(pwaInfo)

function ReloadPrompt() {

  // replaced dynamically
  const buildDate = '__DATE__'
  // replaced dyanmicaly
  const reloadSW = '__RELOAD_SW__'

  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(swUrl, r) {
      console.log(`Service Worker at: ${swUrl}`)
      // @ts-expect-error just ignore
      if (reloadSW === 'true') {
        r && setInterval(() => {
          console.log('Checking for sw update')
          r.update()
        }, 20000 /* 20s for testing purposes */)
      }
      else {
        // eslint-disable-next-line prefer-template
        console.log('SW Registered: ' + r)
      }
    },
    onRegisterError(error) {
      console.log('SW registration error', error)
    },
  })

  useEffect(() => {
   if(offlineReady) {
    toast("App has successfully installed")
   }
   if(needRefresh) {
    toast("App requires update.",{
      duration: Infinity,
      action: {
        label: 'Update now',
        onClick: () => updateServiceWorker()
      },
    })
   }
  }, [needRefresh, offlineReady]);

  const close = () => {
    setOfflineReady(false)
    setNeedRefresh(false)
  }

  return null
}

export default ReloadPrompt